import { message } from 'antd'
import axios from 'axios'

import { clearCsrfToken, getCsrfToken } from '~/utils/auth'

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use(function (config) {
  if (config.headers) {
    config.headers['x-csrf-token'] = getCsrfToken()
  }
  return config
})

axiosInstance.interceptors.response.use(undefined, async function (err) {
  // Canceled requests are expected during query replacement and React Strict
  // Mode's development-only effect replay. Axios 0.26 cancel errors do not
  // retain the request config, so `skipErrorHandler` cannot suppress the toast.
  if (axios.isCancel(err)) {
    return Promise.reject(err)
  }

  const { response, config } = err
  const status = response?.status
  const skipErrorHandler = config?.skipErrorHandler ?? false
  if (status === 401) {
    clearCsrfToken()

    // redirect to login
    // message.warn({ content: 'Please login first', key: 'need_login' })
    const locationHash = window.location.hash
    if (locationHash.startsWith('#/login')) {
      return
    }
    let nextUrl = `${window.location.pathname}#/login`
    if (locationHash.length > 2 /* aka '#/' */) {
      const fromFull = window.location.href
      nextUrl = `${nextUrl}?next=${encodeURIComponent(fromFull)}`
    }
    window.location.assign(nextUrl)
    // don't return error
  } else if (status === 403) {
    // TODO: remove this handle method when group auth api gets ready
    if (!skipErrorHandler) {
      if (
        err.request.responseURL.includes('/fault/api/') ||
        err.request.responseURL.includes('/chaos/api/')
      ) {
        const errMsg = "You don't have permission to acccess drill test"
        message.error({ content: `Error: ${errMsg}`, key: errMsg })
      } else {
        // window.location.assign('/403.html')
        const errMsg = response?.data?.message ?? err.message
        message.error({ content: `Error: ${errMsg}`, key: errMsg })
      }
    }
    return Promise.reject(err)
  } else {
    // If the component decides to handle the error by itself,
    // we don't show error message here
    if (!skipErrorHandler) {
      const errMsg = response?.data?.message ?? err.message
      message.error({ content: `Error: ${errMsg}`, key: errMsg })
    }
    return Promise.reject(err)
  }
})

export { axiosInstance }
